import { FOfferType } from '../../../../../packages/JsonQuery';

export const OFFER_TYPE_OPTIONS = [
  { value: FOfferType.Residential, text: 'Жилая' },
  {
    value: FOfferType.Commercial,
    text: 'Коммерческая',
  },
];
